import { VendorService } from '@controlling/proxy/controlling/controllers';
import { PersonService, QuickResponseCodeService } from '@general/proxy/general/controllers';
import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('General');

export const VENDORPERPERSON_FIELDS: FieldDefinition[] = [
  FieldBuilder // TODO: when the orchestrator is implemented, refactor this nested logic into it
    .foreignKey('vendorId', 'Entity.Vendor', VendorService)
    .required()
    .display('fantasyName')
    .keyField('id')
    .build(),
  FieldBuilder
    .foreignKey('quickResponseCodeId', 'Entity.QuickResponseCode', QuickResponseCodeService)
    .displayFromNested('quickResponseCode.qrCode')
    .sortBy('quickResponseCode.qrCode')
    .build(),
  FieldBuilder
    .date('validFrom', 'Entity.VendorPerPerson.ValidFrom')
    .required()
    .build(),
  FieldBuilder
    .date('validTo', 'Entity.VendorPerPerson.ValidTo')
    .build(),
  FieldBuilder
    .checkbox('isActive', 'Entity.VendorPerPerson.IsActive')
    .build(),
  FieldBuilder
    .foreignKey('personId', 'Entity.Person', PersonService)
    .required()
    .displayFromNested('person.name')
    .sortBy('person.name')
    .hideInChildForms()
    .build(),
];

export const VENDORPERPERSON_CONFIG = {
  entityName: 'VendorPerPerson',
  localizationKey: 'General::Entity.VendorPerPerson',
  fields: VENDORPERPERSON_FIELDS,
  permission: 'GeneralPersons.VendorPerPersons',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.General + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Persons + MENU_NAME_SUFFIX,
};
